module.exports = __webpack_public_path__ + "img/sree_photo.8d02be20.jpg";